class AdFonts {

    constructor($uibModal, EVENTS) {
        
        this.$uibModal = $uibModal;
        this.EVENTS = EVENTS;

        return {
            restrict: 'E',
            templateUrl: "builder/ad-fonts.html",
            scope: {
            	"adunit": "="
            },
            link: ($scope, $el, $attr) => {

                $scope.testText = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                $scope.fontList = {};

                $scope.deleteFont = (fontName) => {
                    $scope.adunit.fonts = $scope.adunit.fonts.filter( (font) => font.name !== fontName );
                    this.parseFonts($scope, $el);
                };

                $scope.showReflowFonts = () => {

                    var inst = this.$uibModal.open({
                        templateUrl: 'reflow-font-picker.html',
                        controller: 'ReflowFontsPicker',
                        windowClass: 'google-font-index',
                        backdropClass: 'google-font-backdrop-index',
                        size: "lg",
                        resolve: {

                        }
                    });

                    inst.result.then( (fontList) => {
                        fontList.forEach(f => {
                            $scope.adunit.fonts.push(f);
                        })
                        this.parseFonts($scope, $el);
                    });

                }

                $scope.showGoogleFonts = () => {

                    var inst = this.$uibModal.open({
                        templateUrl: 'google-font-picker.html',
                        controller: 'GoogleFontsPicker',
                        windowClass: 'google-font-index',
                        backdropClass: 'google-font-backdrop-index',
                        size: "lg",
                        resolve: {

                        }
                    });

                    inst.result.then( (fontList) => {

                        $.each(fontList, (ix, f) => {
                            let font = {
                                isGoogle: true,
                                name: f.family,
                                variants: []
                            };
                            f.variants.forEach( (x) => {
                                font.variants.push({ name: x, selected: x === "regular" || x === "bold" ? true : false });
                            })
                            $scope.adunit.fonts.push(font);
                            this.parseFonts($scope, $el);
                        });
                        
                    }, () => {
                        
                    });

                };

                $scope.$watch("adunit", (newitem) => {
                    if(newitem != null) {
                        if("undefined" === typeof newitem.fonts) {
                            newitem.fonts = [];
                        }
                        this.parseFonts($scope, $el);
                    }
                });                
                
                $el.droppable({
                    greedy: true,
                    tolerance: "pointer",
                    accept: (draggable) => {                        
                        var widget = $(draggable).data("reflow-font");
                        return (!!widget);
                    },
                    over: (ev, ui) => {

                    },
                    out: (ev, ui) => {

                    },
                    drop: (ev, ui) => {
                        var widget = $(ui.draggable).data("reflow-font");
                        if(!!widget) {
                            $scope.adunit.fonts.push(widget);
                            if(widget.name.length > 31) {
                                $scope.$emit(this.EVENTS.SHOW_NOTIFICATION, {'message': "The selected font may not be supported by Internet Explorer as only font-familes names less than 32 characters are supported.", "messageType": "warning"});
                            }
                        }
                        this.parseFonts($scope, $el);
                        $scope.$apply();
                    }
                });

            }
        };

    }

    parseFonts($scope, $el) {

        $(".font-styles", $el).empty();

        $scope.fontList = {};

        $scope.adunit.fonts.forEach( (font) => {

            if("undefined" === typeof $scope.fontList[font.name]) {
                $scope.fontList[font.name] = {
                    name: font.name,
                    sources: [],
                    isGoogle: !!font.isGoogle,
                    variants: font.variants
                };
            }

            if($scope.fontList[font.name].sources.indexOf(font.src) < 0) {
                $scope.fontList[font.name].sources.push(font.src);
            }

        });

        $.each($scope.fontList, (k, v) => {

            v.isChrome = false;
            v.isFirefox = false;
            v.isSafari = false;
            v.isOpera = false;
            v.isIE = false;

            if(!!v.isGoogle) {
                v.family = k;
                v.name = k + " (Google Font)";
                $(".font-styles", $el).append("<link rel='stylesheet' type='text/css' href='https://fonts.googleapis.com/css?family=" + encodeURIComponent(k) + "''>");
                v.isChrome = true;
                v.isFirefox = true;
                v.isSafari = true;
                v.isOpera = true;
                v.isIE = true;
            }
            else {

                v.rule = "@font-face {";
                v.rule += "font-family: '" + k + "';";

                var formats = [];
                var sources = [];
                v.sources.forEach( (s) => {

                    let source = "";

                    if(s.startsWith("http")) {
                        source += "url('" + s + "') ";
                    }
                    else {
                        source += "url('https://storage.googleapis.com/assets-scenestealer-210713/" + s + "') ";
                    }

                    if(s.endsWith(".woff2")) {
                        formats.push("woff2");
                        source += "format('woff2')";
                        v.isChrome = true;
                        v.isFirefox = true;
                        v.isOpera = true;
                    }
                    else if(s.endsWith(".woff")) {
                        formats.push("woff");
                        source += "format('woff')";
                        v.isChrome = true;
                        v.isFirefox = true;
                        v.isSafari = true;
                        v.isOpera = true;
                        v.isIE = true;
                    }
                    else if(s.endsWith(".ttf")) {
                        formats.push("ttf");
                        source += "format('truetype')";
                        v.isChrome = true;
                        v.isFirefox = true;
                        v.isSafari = true;
                        v.isOpera = true;
                        v.isIE = true;
                    }
                    else if(s.endsWith(".eot")) {
                        formats.push("eot");
                        source += "format('embedded-opentype')";
                        v.isIE = true;
                    }

                    if(sources.indexOf(source) < 0) {
                        sources.push(source);
                    }

                });

                if(k.length > 31) {
                    v.isIE = false;
                }

                v.rule += "src: " + sources.join(", ") + ";";
                v.rule += "}";
                v.family = k;
                v.name = k + " (" + formats.join(",") + ")";

                $(".font-styles", $el).append("<style>" + v.rule + "</style>");
            }


        });

        
        
    }

}

class GoogleFontsPicker {
    
    constructor($scope, $uibModalInstance, $builderService, $sce) {

        this.$scope = $scope;
        this.$builderService = $builderService;
        this.$scope.selectedFonts = [];

        this.$scope.fontUrl = (font) => {
            if(!!font) {
                return $sce.trustAsResourceUrl("https://fonts.googleapis.com/css?family=" + encodeURIComponent(font.family));
            }
            else {
                return "Open Sans";
            }
        };

        this.loadFonts();
        
        $scope.ok = () => {
            this.$scope.selectedFonts = this.$scope.fonts.filter( x => x.selected );
            $uibModalInstance.close($scope.selectedFonts);
        };

        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

    }

    loadFonts() {
        this.$builderService.getGoogleFonts().then( (response) =>{
            this.$scope.fonts = response.data.items;
        });
    }

}

class ReflowFontsPicker {
    
    constructor($scope, $uibModalInstance, $builderService, SERVICE_LOCATIONS, EVENTS, $timeout, FOLDER_CONSTANTS, AssetService) {

        this.$scope = $scope;
        this.$builderService = $builderService;
        this.$scope.selectedFonts = [];
        this.AssetService = AssetService;
        this.FOLDER_CONSTANTS = FOLDER_CONSTANTS


        $timeout(() => {

            let element = $(".google-font-index").first();

            element.on("dragenter", (ev) => {
                ev.stopPropagation();
                ev.preventDefault();
            });

            element.on("dragover", (ev) => {
                ev.stopPropagation();
                ev.preventDefault();
            });

            element.on("dragleave", (ev) => {
                ev.stopPropagation();
                ev.preventDefault();

            });

            element.on("drop", (ev) => {
                ev.stopPropagation();
                ev.preventDefault();
                let files = ev.originalEvent.dataTransfer.files;
                if(files.length > 0) {
                   this.AssetService.uploadFile(this.FOLDER_CONSTANTS.REFLOW_FONTS, files[0],                        
                        (data) => { // completion callback
                            this.loadFonts();
                            this.$scope.$apply();
                        },
                        (status) => { // progress callback
                            this.$scope.$apply();                           
                        }
                    )
                }
            })
            // });


            $(document).on("dragleave", (ev) => {
                ev.stopPropagation();
                ev.preventDefault();

            }); 
        }, 0);

        this.loadFonts();
        
        $scope.ok = () => {
            this.$scope.selectedFonts = this.$scope.fonts.filter( x => x.selected );
            $uibModalInstance.close($scope.selectedFonts);
        };

        $scope.cancel = () => {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.showAddNotification = ()  => {
            $scope.$emit(EVENTS.SHOW_NOTIFICATION, { 'message': "Drop one or more fonts into the modal." });
        }

    }

    loadFonts() {
        this.$builderService.getReflowFonts().then( (response) =>{
            // console.log(response.data)
            this.$scope.fonts = response;
            console.log(this.$scope.fonts);
        });
    }

}

angular.module('cpm').controller("ReflowFontsPicker", ["$scope", '$uibModalInstance', "$builderService", "SERVICE_LOCATIONS", "EVENTS", "$timeout", "FOLDER_CONSTANTS", "AssetService", ReflowFontsPicker]);
angular.module('cpm').controller("GoogleFontsPicker", ["$scope", '$uibModalInstance', "$builderService", "$sce", GoogleFontsPicker]);


angular.module('cpm')
    .directive('adFonts', ['$uibModal', 'EVENTS', ($uibModal, EVENTS) => {
	    'use strict';
	    return new AdFonts($uibModal, EVENTS);
	}]);
